import { render } from "./CreateCluster.vue?vue&type=template&id=587203de"
import script from "./CreateCluster.vue?vue&type=script&lang=js"
export * from "./CreateCluster.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./CreateCluster.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/Users/shaohuanqing/dev/kuboard-spray/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__